import React from 'react';
import {resolveColor} from '../../../utils/colors';

const ValuesGrid = ({width = '14px', height = '14px', color}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.66667 8.83325V7.99992M9 8.83325V6.33325M12.3333 8.83325V4.66659M5.66667 15.4999L9 12.1666L12.3333 15.4999M1.5 1.33325H16.5M2.33333 1.33325H15.6667V11.3333C15.6667 11.7935 15.2936 12.1666 14.8333 12.1666H3.16667C2.70643 12.1666 2.33333 11.7935 2.33333 11.3333V1.33325Z"
                stroke={resolveColor(color) || '#6E6C6C'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
};
export default ValuesGrid;
